import React, { useState } from 'react';
import Link from 'next/link';
import { headerStyles } from './header.styles';
import { Box, Flex, Text, Image, Button } from '@chakra-ui/react';
import useAuthFunc from '@/hooks/auth/useAuthFunc';
import { User } from '@/core/models';
import PoliceEncounterModal from '../Incidents/police-encounter/PoliceEncounterModal';
import { HiUserGroup } from 'react-icons/hi2';

const HeaderDropdown = ({ user }: { user: User }) => {
   const { handleLogout } = useAuthFunc();
   const [showDropdown, setShowDropdown] = useState(false);
   const [police_encounter, setPoliceEncounter] = useState(false);
   return (
      <Box position="relative">
         <Flex align="center" gap="20px" onClick={() => setShowDropdown(state => !state)} cursor="pointer">
            <Box
               bg="#ffffff5e"
               h="24px"
               borderRadius="8px"
               px="10px"
               alignItems="center"
               justifyContent="center"
               display={{ base: 'none', md: 'flex' }}
            >
               <Text textStyle="xs" color="white">
                  380 CanPoints
               </Text>
            </Box>
            <Flex align="center" gap="10px">
               <Text
                  textStyle="sm"
                  fontWeight="700"
                  color="white"
                  textTransform="uppercase"
                  display={{ base: 'none', md: 'block' }}
               >
                  Hello, {user?.first_name}
               </Text>
               <Image
                  src={user?.profile_photo?.url || '/assets/images/user-not-found.png'}
                  alt="admin"
                  objectFit="cover"
                  style={{ borderRadius: '50%', height: '36px', width: '36px' }}
               />
            </Flex>
         </Flex>
         {showDropdown && (
            <Box css={headerStyles.login_dropdown} border="1px solid #ffffff5e">
               <Flex align="center" gap="20px" mb="3">
                  <Image
                     src={user?.profile_photo?.url || '/assets/images/user-not-found.png'}
                     alt="admin"
                     objectFit="cover"
                     style={{ borderRadius: '50%', height: '36px', width: '36px' }}
                  />
                  <Box>
                     <Text textStyle="sm" fontWeight="700" color="white" mb="1">
                        {user?.first_name} {user?.last_name}
                     </Text>
                     <Text textStyle="xs" fontWeight="500" color="white" wordBreak="break-all">
                        {user?.email}
                     </Text>
                  </Box>
               </Flex>
               <Box as="ul" mt="4">
                  <Text as="li" css={headerStyles.login_dropdown_menu}>
                     <Link
                        onClick={() => setShowDropdown(false)}
                        href="/manage-profile"
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '20px',
                           fontSize: '12px',
                           fontWeight: '600',
                           color: 'white',
                           padding: '15px 0',
                        }}
                     >
                        <Image src="/assets/icons/manage_profile_icon.svg" alt="admin" width="20px" height="20px" />
                        <Text>Manage Profile</Text>
                     </Link>
                  </Text>
                  <Text as="li" css={headerStyles.login_dropdown_menu}>
                     <Link
                        onClick={() => setShowDropdown(false)}
                        href="/view-card"
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '20px',
                           fontSize: '12px',
                           fontWeight: '600',
                           color: 'white',
                           padding: '15px 0',
                        }}
                     >
                        <Image src="/assets/icons/view_card_icon.svg" alt="admin" width="20px" height="20px" />
                        <Text>View Card</Text>
                     </Link>
                  </Text>
                  <Text as="li" css={headerStyles.login_dropdown_menu}>
                     <Link
                        onClick={() => setShowDropdown(false)}
                        href="/clinic-directory"
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '20px',
                           fontSize: '12px',
                           fontWeight: '600',
                           color: 'white',
                           padding: '15px 0',
                        }}
                     >
                        <Image src="/assets/icons/clinic_directory_icon.svg" alt="admin" width="20px" height="20px" />
                        <Text>Clinic Directory</Text>
                     </Link>
                  </Text>
                  <Text as="li" css={headerStyles.login_dropdown_menu}>
                     <Link
                        onClick={() => setShowDropdown(false)}
                        href="/my-referrals"
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '20px',
                           fontSize: '12px',
                           fontWeight: '600',
                           color: 'white',
                           padding: '15px 0',
                        }}
                     >
                        {/* <Image src="/assets/icons/clinic_directory_icon.svg" alt="admin" width="20px" height="20px" /> */}
                        <HiUserGroup color="yellow" />
                        <Text>My Referrals</Text>
                     </Link>
                  </Text>
                  <Text as="li" css={headerStyles.login_dropdown_menu}>
                     <Link
                        href="/raffle"
                        onClick={() => setShowDropdown(false)}
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '20px',
                           fontSize: '12px',
                           fontWeight: '600',
                           color: 'white',
                           padding: '15px 0',
                        }}
                     >
                        <Image src="/assets/icons/raffles_icon.svg" alt="admin" width="20px" height="20px" />
                        <Text>Raffles</Text>
                     </Link>
                  </Text>
                  <Text as="li" css={headerStyles.login_dropdown_menu}>
                     <Link
                        href="/exclusive-membership-benefits"
                        onClick={() => setShowDropdown(false)}
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '20px',
                           fontSize: '12px',
                           fontWeight: '600',
                           color: 'white',
                           padding: '15px 0',
                        }}
                     >
                        <Image src="/assets/icons/member_benefit_icon.svg" alt="admin" width="20px" height="20px" />
                        <Text>Exclusive Member Benefits</Text>
                     </Link>
                  </Text>
                  <Text as="li" css={headerStyles.login_dropdown_menu}>
                     <Link
                        href="/get-offer-code"
                        onClick={() => setShowDropdown(false)}
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '20px',
                           fontSize: '12px',
                           fontWeight: '600',
                           color: 'white',
                           padding: '15px 0',
                        }}
                     >
                        <Image src="/assets/icons/offer_code_icon.svg" alt="admin" width="20px" height="20px" />
                        <Text>Get Your Offer Code</Text>
                     </Link>
                  </Text>
                  <Text as="li" css={headerStyles.login_dropdown_menu}>
                     <Button
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '20px',
                           fontSize: '12px',
                           fontWeight: '600',
                           color: 'white',
                           padding: '15px 0',
                           background: 'transparent',
                           outline: 'none',
                        }}
                        onClick={() => setPoliceEncounter(true)}
                     >
                        <Image src="/assets/icons/stopped_police_icon.svg" alt="admin" width="20px" height="20px" />
                        <Text>Got Stopped By Police</Text>
                     </Button>
                  </Text>
                  <Text as="li" css={headerStyles.login_dropdown_menu}>
                     <Text
                        onClick={async () => await handleLogout()}
                        as="button"
                        style={{
                           display: 'flex',
                           alignItems: 'center',
                           gap: '20px',
                           fontSize: '12px',
                           fontWeight: '600',
                           color: 'white',
                           padding: '15px 0',
                           cursor: 'pointer',
                        }}
                     >
                        <Image src="/assets/icons/sign_out_icon.svg" alt="admin" width="20px" height="20px" />
                        <Text>Sign Out</Text>
                     </Text>
                  </Text>
               </Box>
            </Box>
         )}
         {police_encounter && (
            <PoliceEncounterModal isOpen={police_encounter} onClose={() => setPoliceEncounter(false)} />
         )}
      </Box>
   );
};

export default HeaderDropdown;
